import { render } from "./EmptyHome.vue?vue&type=template&id=6cb0f791"
import script from "./EmptyHome.vue?vue&type=script&lang=js"
export * from "./EmptyHome.vue?vue&type=script&lang=js"

import "./EmptyHome.vue?vue&type=style&index=0&id=6cb0f791&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__